import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const BalloonHearts = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.372 4.521a3.407 3.407 0 0 0-3.294-3.273A3.12 3.12 0 0 0 8.3 3.331a3.12 3.12 0 0 0-2.979-1.784 3.41 3.41 0 0 0-2.933 3.6c.2 3.763 5.55 6.553 6.347 6.511M6.128 7.2a3.7 3.7 0 0 1-1.243-2.186 1.06 1.06 0 0 1 .566-.971m7.604 7.307a3.7 3.7 0 0 1-.91-2.342 1.06 1.06 0 0 1 .7-.878m-2.614 5.655 1.332 8.971m2.508-.017.494-3.341m-.685-2.107c-.984.95 2.705 1.41 1.985.247M18.82 6.184a3.12 3.12 0 0 0-3.05 1.656 3.12 3.12 0 0 0-2.689-2.2 3.407 3.407 0 0 0-3.426 3.133c-.355 3.751 4.534 7.291 5.33 7.366S21.247 13.654 21.6 9.9a3.407 3.407 0 0 0-2.78-3.716"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(BalloonHearts) as SvgIcon;
export { ForwardRef as ReactComponent };
